import { apiClient } from './client';

/** 관리자 정산 목록 조회 요청 (AdminSettlementAmountRequestDto) */
export interface GetSettlementAmountParams {
  page?: number;
  size?: number;
  searchKeyword?: string;
  startDate?: string;
  endDate?: string;
  sortBy?: string;
  sortOrder?: string;
  /** 정산 상태 (ALL: 전체, N: 미정산, Y: 완료). 그룹(사업장×월) 파생값 기준 */
  settlementStatus?: 'ALL' | 'Y' | 'N';
}

/** 검색 조건 전체 기준 집계 — 현재 페이지가 아닌 전체 */
export interface SettlementSummary {
  totalGroups: number;
  pendingGroups: number;
  completedGroups: number;
  completeAmount: number;
  remainAmount: number;
}

export interface SettlementAmountPagination {
  currentPage: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
}

export interface AdminSettlementAmountInfo {
  yearMonth: string;
  id: string;
  companyName: string;
  businessNumber: string;
  dtDeposit: string | null;
  settlementCompleteAmount: number;
  remainSettlementAmount: number;
  settlementStatus: string;
  companySeq: number;
}

export interface AdminSettlementAmountResponse {
  content: AdminSettlementAmountInfo[];
  pagination: SettlementAmountPagination;
  /** 전체 집계 (상태 필터 미적용 — 탭 배지/통계 카드용) */
  summary?: SettlementSummary;
}

/** 월별 정산 상세 조회 요청 */
export interface GetSettlementMonthDetailParams {
  yearMonth: string;
  companySeq: number;
  id?: string;
  companyName?: string;
  businessNumber?: string;
}

/** 월별 정산 상세 행 (온라인/오프라인 공통) */
export interface SettlementMonthDetailItem {
  paymentSeq: number;
  paymentType: string;
  userSeq: number;
  userName: string;
  userEmail: string;
  phoneNumber: string;
  companyName: string;
  ticketName: string;
  splitCount: number;
  dtRegist: string;
  salesAmount: number;
  pgFee: number;
  pgFeeRate: number;
  serviceFee: number;
  serviceFeeRate: number;
  settlementAmount: number;
  status: string;
  settlementSeq: number;
  dtDeposit: string | null;
}

export interface SettlementMonthDetailResponse {
  online: SettlementMonthDetailItem[];
  /** @deprecated 크레딧 도입 이후 오프라인 정산 미운영 — 백엔드 응답 형태 유지용(항상 빈 배열) */
  offline: SettlementMonthDetailItem[];
}

export const settlementAmountApi = {
  getList: async (
    params: GetSettlementAmountParams = {}
  ): Promise<AdminSettlementAmountResponse> => {
    const response = await apiClient.get<AdminSettlementAmountResponse>(
      '/admin/settlementAmount',
      { params }
    );
    return response.data;
  },

  getMonthDetail: async (
    params: GetSettlementMonthDetailParams
  ): Promise<SettlementMonthDetailResponse> => {
    const response = await apiClient.get<SettlementMonthDetailResponse>(
      '/admin/settlementAmount/month',
      { params }
    );
    return response.data;
  },

  /** 건별 정산 처리 */
  updateStatus: async (settlementSeqs: number[]): Promise<void> => {
    const payload = settlementSeqs.map(settlementSeq => ({ settlementSeq }));
    await apiClient.put('/admin/settlementAmount', payload);
  },
};
